import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type Language = 'ar' | 'en';

@Injectable({
  providedIn: 'root'
})
export class LangService {
  private currentLangSubject = new BehaviorSubject<Language>('en');
  currentLang$ = this.currentLangSubject.asObservable();

  constructor() {
    this.initializeLanguage();
  }

  private initializeLanguage(): void {
    const savedLang = localStorage.getItem('language') as Language;
    if (savedLang && (savedLang === 'ar' || savedLang === 'en')) {
      this.setLanguage(savedLang);
    } else {
      this.setLanguage('en');
    }
  }

  setLanguage(lang: Language): void {
    // Update HTML attributes immediately
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';
    
    // Add/remove RTL class to body immediately
    if (lang === 'ar') {
      document.body.classList.add('rtl');
      document.body.classList.remove('ltr');
    } else {
      document.body.classList.add('ltr');
      document.body.classList.remove('rtl');
    }
    
    // Update the subject after DOM changes
    this.currentLangSubject.next(lang);
    localStorage.setItem('language', lang);
  }

  getCurrentLang(): Language {
    return this.currentLangSubject.value;
  }

  isRTL(): boolean {
    return this.getCurrentLang() === 'ar';
  }

  toggleLanguage(): void {
    const newLang = this.getCurrentLang() === 'en' ? 'ar' : 'en';
    this.setLanguage(newLang);
  }
}
